import { Injectable } from "@angular/core";
import _ from "lodash";

@Injectable({
  providedIn: "root",
})
export class CtripPriceFormService {
  constructor() {}

  /**
   * 根据佣金和底价计算卖价
   */
  calculateSalePrice(commission, reservePrice) {
    if (_.isNil(commission) || _.isNil(reservePrice)) {
      return undefined;
    }

    const result = reservePrice / ((100 - commission) / 100);
    return Number.isInteger(result) ? result : result.toFixed(2);
  }

  /**
   * 根据佣金和卖价计算底价
   */
  calculateReservePrice(commission, salePrice) {
    if (_.isNil(commission) || _.isNil(salePrice)) {
      return undefined;
    }

    const result = (salePrice * (100 - commission)) / 100;
    return Number.isInteger(result) ? result : result.toFixed(2);
  }
}
